import { useQuery } from "@tanstack/react-query";
import { getMeals } from "../services/firebase";
import { getGuestMeals } from "../services/guestStorage";

// Hook for fetching Meals (supports guest mode via localStorage)
export const useMeals = (uid) => {
  const isGuest = !uid || uid === "guest";

  return useQuery({
    queryKey: ["meals", uid],
    queryFn: () => (isGuest ? getGuestMeals() : getMeals(uid)),
    enabled: true,
    staleTime: isGuest ? 0 : 1000 * 60 * 2,
  });
};
